import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { fetchAllResume, resumeSelector  } from '../../api/cv'
import Datatable from './datatable'
import ExportExcel from './exportExcel'

export default function Index() {
    const dispatch = useDispatch()
    const {resume} = useSelector(resumeSelector)
    console.log({resume})


    useEffect(()=>{
        dispatch(fetchAllResume())
    },[dispatch])
  return (
    <>
    <div className="mb-4 float-right ">
    <div className="mx-3">

{/* <Search placeholder="Search Events" className="mx-3" style={{ width: 230 }} enterButton /> */}
   
    <ExportExcel data = {resume}/>
    
</div>
</div>
{

 <Datatable data ={resume}/>

}
    </>
  )
}

 